import { transition } from "@codesandbox/states";

import { isUrl } from "utils/url";

import type { State, Action } from "./types";

export const featureReducer = (prevState: State, action: Action) =>
  transition(prevState, action, {
    CONNECTING: {
      "PITCHER:CONNECTED": (state): State => ({
        ...state,
        state: "READY",
      }),
    },
    READY: {
      NAVIGATE_TO: (state, { url }): State => {
        let newUrl = url;

        if (!isUrl(url)) {
          // In case the user types a partial path, append the base url at the beginning
          newUrl = new URL(url, state.origin).href;
        }

        return {
          ...state,
          iframeSrc: newUrl,
          url: newUrl,
          urlInputValue: newUrl,
          canGoBack: false,
          canGoForward: false,
        };
      },
      /**
       * Tracking events
       * */
      TRACK: (state, { url: newUrl, canGoBack, canGoForward }) => {
        return {
          // src is intentionally not changed. This is to prevent the preview from reloading.
          ...state,
          // Update the url to reflect user navigation inside the preview
          url: newUrl,
          urlInputValue: newUrl,
          canGoBack,
          canGoForward,
        };
      },
      /**
       * Input events
       */
      INPUT_CHANGE: (state, { url }) => {
        return {
          ...state,
          urlInputValue: url,
        };
      },
      INPUT_CANCEL: (state) => {
        return {
          ...state,
          urlInputValue: state.url,
        };
      },
      UPDATE_ORIGIN: (state, { newOrigin, newUrl }) => ({
        ...state,
        origin: newOrigin,
        iframeSrc: newUrl,
        url: newUrl,
        urlInputValue: newUrl,
      }),
    },
  });
